import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const About = () => {
  usePageTitle('소개');

  return (
    <Container>
      <Row>
        <Col>
          <h3>전략 자세히 보기</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            가치 투자서 '현명한 투자자 - 벤저민 그레이엄'에 나오는 전략을
            바탕으로 저평가 된 종목을 찾아보세요.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              주식 선정 4대 기준 <small>(87 페이지)</small>
            </Card.Header>
            <Card.Body>
              <blockquote className="blockquote fs-6">
                <p>
                  <small>...</small>
                  <br />
                  2. 재무구조가 건전한 유명 대기업들 중에서만 선정한다.
                  <br />
                  3. 장기간 지속적으로 배당을 지급한 기업들 중에서만 선정한다.
                  <br />
                  4. 과거 평균 이익의 25배 이하인 동시에, 최근 12개월 이익의
                  20배 이하
                  <br />
                  <small>...</small>
                </p>
                <footer className="blockquote-footer">
                  <cite title="5장 | 방어적 투자자의 주식투자">
                    5장 | 방어적 투자자의 주식투자
                  </cite>
                </footer>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              공격적 투자자에게 추천하는 세 가지 투자 기법{' '}
              <small>(119 페이지)</small>
            </Card.Header>
            <Card.Body>
              <blockquote className="blockquote fs-6">
                <p>
                  1. 소외된 대형주에 투자
                  <br />
                  <small>...</small>
                  <br />
                  실적 부진 등으로 소외된 주식은 시장에서 저평가된다고 보아야
                  논리적이다.
                  <br />
                  <small>...</small>
                </p>
                <footer className="blockquote-footer">
                  <cite title="7장 | 공격적 투자자의 포트폴리오 전략: 해볼만한 투자">
                    7장 | 공격적 투자자의 포트폴리오 전략: 해볼만한 투자
                  </cite>
                </footer>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <ul>
            <li>재무구조가 건전한 유명 대기업: 시총 상위 100개 기업</li>
            <li>이익의 25배 이하: 추정 EPS 기반의 PER</li>
            <li>소외된 대형주: 고점 대비 하락률</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};
